var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviIcCommunityDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28h28V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.5 9h9M9.5 13h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28h28V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.12 11.199-1.67-1.09v9.81l-1.32.66V9.259l-1.92-1.25.72-1.1 4.25 2.84-.06 1.45zm-5.6-3.48-3.32-1.84-1.71.96v6.3H17v1.32h-4.51v8.17l-1.32-.82V6.419l.32-.53 2.4-1.35h.61l.02.01 3.64 2.01-.64 1.16zm-7.29 13.78-1.28-.78-.01-.04-1.97-6.36v5.42l-1.31-.83v-9.29l1.25-.67 2 7.11v-8.46l1.32-.83v14.73zm14.17-14.7-9-4.99a2.85 2.85 0 0 0-2.8 0l-9 4.99c-.94.52-1.52 1.51-1.52 2.59v9.22c0 1.08.58 2.07 1.52 2.59l9 4.99c.44.25.92.37 1.4.37.48 0 .96-.12 1.4-.37l9-4.99c.94-.52 1.52-1.51 1.52-2.59v-9.22c0-1.08-.58-2.07-1.52-2.59z",
    fill: "#E5E6E8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviIcCommunityDisabled);
export default __webpack_public_path__ + "static/media/navi-ic-community-disabled.3a0351e5be8ef61f5be5386ba0b14ae5.svg";
export { ForwardRef as ReactComponent };